
import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import {MdKeyboardArrowRight} from "react-icons/md"
import { useEffect } from "react"
import {
    getGeocode,
    getLatLng,
  } from 'use-places-autocomplete';
import { updateRoute, updateRoutePoint } from "../../../features/kmCalc/kmCalcSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { getAdresAutoComplete } from "../../../features/address/addressSlice"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        color: ${({ theme }) => theme.mainTextColor};
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 300px;
        overflow: auto;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            color: ${({ theme }) => theme.mainTextColor};
            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }

`

const InputPlacesForKmHesaplama = ({ labelText, name, inputWidth, routeItem}) => {
    
    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)


    useEffect(() => {
        dispatch(getAdresAutoComplete({
                searchText: routeItem?.searchText,
                kmHesaplamaRouteItemId: routeItem?.id
            })
        )

    },[routeItem.searchText])

    const handleOptionClick = async (optionItem) => {
        try {
            dispatch(handleActiveSelect(null))
            const results = await getGeocode({ address:optionItem?.description });
            const { lat, lng } = await getLatLng(results[0]);

            dispatch(updateRoutePoint({
                id: routeItem?.id,
                searchText: optionItem?.description,
                location:optionItem?.description,
                lat,
                lng
            }))

            
        } 

        catch (error) {
            // console.log(error);
        }
      
    }


  return (
    <Container value={routeItem?.searchText} radius={"5px"} isActive={activeSelect === name} inputWidth={inputWidth} onClick={(e) => e.stopPropagation()}>
        
        <input type="text" id={"text"} onChange={(e) => {        dispatch(updateRoutePoint({
            searchText: e.target?.value,
            id: routeItem?.id
        })); dispatch(handleActiveSelect(name))}} value={routeItem?.searchText} name={name} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        routeItem?.locationOptions?.map((item) => (
                        <div className="option" onClick={() => handleOptionClick(item)}>{item?.description}</div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default InputPlacesForKmHesaplama